/**
 * MIONGA content — 4 languages (EN default, PT, DE, FR).
 * Reuses the site-wide language pref stored in localStorage.hx_lang.
 */
const M = {
  en: {
    nav: { vision: "Vision", ecosystem: "Ecosystem", products: "Products", sustainability: "Sustainability", partnership: "Partnership", request: "Request Partnership" },
    hero: {
      badge: "Premium Lifestyle Ecosystem",
      subline: "Beverages",
      slogan: "\u201CNatural Flavors from the Islands, Crafted in Germany.\u201D",
      poweredBy: "Powered by Moin | Ol\u00e1 Coffee Connection",
      cta1: "Explore the Ecosystem",
      cta2: "Partnership Opportunity",
      placeholder: "Hero \u2014 MIONGA bottle \u00b7 oak table \u00b7 coffee",
    },
    vision: {
      eyebrow: "The Vision", title: "Building a New", accent: "Lifestyle Ecosystem.",
      lede: "MIONGA combines premium beverages, coffee culture, gastronomy and sustainable hospitality into one integrated experience.",
      pillars: ["Premium Beverages", "Coffee Connection", "Hospitality Experience", "Family Concept", "Sustainable Future"],
    },
    ecosystem: {
      eyebrow: "Ecosystem Map", title: "Connected by Craft.", center: "Center",
      branches: [
        { title: "Moin | Ol\u00e1 Coffee Connection", items: ["Specialty Coffee", "Breakfast & Brunch", "Mocktails", "Family Experience"] },
        { title: "LIOMONA",            items: ["Botanical Lemonades", "Natural Refreshments"] },
        { title: "MIONGA Collection",  items: ["Water", "Juice", "Tea", "Coffee"] },
      ],
    },
    flagship: {
      eyebrow: "Flagship Experience", title: "More than a caf\u00e9.", accent: "A complete lifestyle destination.",
      items: ["Oak Wood interiors", "Exposed Brick walls", "Premium Coffee Bar", "Lounge Area", "Kinderecke \u2014 children's area", "Product Showroom"],
      placeholder: "Flagship interior \u00b7 oak + brick",
      gallery: {
        title: "Inside the flagship",
        lede: "Three defining moments of the Moin | Olá house — day, service and street presence.",
        shots: [
          { key: "interior", label: "01 · Daylight interior", caption: "Oak, brick and morning light — the everyday cathedral." },
          { key: "bar",      label: "02 · Signature bar",     caption: "Barista service, mocktail craft and the Kinderecke — one continuous stage." },
          { key: "outdoor",  label: "03 · Street presence",   caption: "European cobblestone, digital storefront, botanic entrance." },
        ],
      },
    },
    products: {
      eyebrow: "Product Ecosystem", title: "Crafted Naturally.", accent: "Delivered Premium.",
      items: [
        { name: "MIONGA Water",     sub: "Natural mineral water · pH 7.2 · Rich in potassium" },
        { name: "MIONGA Sparkling", sub: "Sparkling mineral water · Refreshing & balanced" },
        { name: "MIONGA Juice",     sub: "Premium juices · 100% natural · No preservatives, no dyes" },
        { name: "MIONGA Iced Tea",  sub: "Premium iced tea · Hand-selected ingredients" },
        { name: "MIONGA Coffee",    sub: "Premium blend · 100% Arabica · Intense aroma, unmistakable flavour" },
      ],
    },
    family: {
      eyebrow: "Family Experience", title: "Small Flavors,", accent: "Big Discoveries.",
      items: ["Moin | Ol\u00e1 Kids \u2014 signature children menu", "Kinderecke \u2014 dedicated children's area", "Healthy drinks for growing minds", "Family-friendly hospitality"],
      placeholder: "Kinderecke \u00b7 family experience",
    },
    sustainability: {
      eyebrow: "Sustainability", title: "Green Operations.", accent: "Responsible Sourcing.",
      items: [
        { title: "Electric Logistics",    body: "Zero-emission delivery fleet across German hubs." },
        { title: "Sustainable Packaging", body: "Glass bottles, compostable materials, closed-loop." },
        { title: "Responsible Sourcing",  body: "Direct-trade partnerships with island growers." },
        { title: "Green Operations",      body: "Renewable-energy roasteries and caf\u00e9s." },
      ],
      placeholder: "Electric fleet \u00b7 sustainable supply chain",
    },
    connection: {
      eyebrow: "International Connection", accentPrefix: "Island heritage", accentBody: "meets German quality.",
      de: { name: "Germany",    sub: "Uetze · Lower Saxony · HQ & Operations" },
      route: "Atlantic Route · ~3,900 km",
      cv: { name: "Cape Verde", sub: "Island Origins · Praia · Sourcing" },
      distanceLabel: "Distance",
      distanceValue: "~3,900 km",
      routeLabel: "Route",
      routeValue: "Atlantic Corridor",
    },
    applications: {
      eyebrow: "Brand Applications",
      title: "One identity,", accent: "every touchpoint.",
      lede: "From the cargo bay to the barista's polo — the MIONGA identity travels consistently across every operational surface.",
      items: [
        { key: "cargo",   label: "Cargo Fleet",   sub: "Full-livery trucks" },
        { key: "uniform", label: "Team Uniform",  sub: "Polo · Cap · Apron" },
        { key: "glass",   label: "Signature Glass", sub: "Etched drinkware" },
        { key: "bag",     label: "Retail Bag",    sub: "Premium takeaway" },
        { key: "hangtag", label: "Hang Tag",      sub: "Product tagging" },
      ],
    },
    model: {
      eyebrow: "Business Model", title: "All-Day", accent: "Revenue.",
      items: [
        { time: "Morning",   what: "Coffee & Breakfast" },
        { time: "Day",       what: "Lunch & Refreshments" },
        { time: "Afternoon", what: "Coffee Experience" },
        { time: "Events",    what: "Hospitality \u00b7 Partnerships" },
        { time: "B2B",       what: "Hotels \u00b7 Resorts \u00b7 Aviation" },
      ],
    },
    partnership: {
      eyebrow: "Partnership", title: "Strategic", accent: "Alliances.",
      lede: "MIONGA partners with premium hospitality, aviation, and distribution networks to deliver an integrated lifestyle experience.",
      targets: ["Luxury Hotels", "Resorts", "Airlines", "Investors", "Distribution", "Institutional"],
      cta: "Request MIONGA Partnership",
      form: {
        title: "Request a partnership briefing",
        lede: "Executive dossier delivered within 48 hours. All submissions confidential.",
        name: "Full name", company: "Company / Organisation", role: "Role (optional)",
        country: "Country", email: "Corporate email", phone: "Phone (optional)",
        interest: "Area of interest", message: "Briefing request",
        interestOptions: {
          "hotels": "Luxury Hotels & Resorts",
          "fine-dining": "Fine Dining · Hospitality",
          "retail": "Premium Retail",
          "aviation": "Aviation & Lounges",
          "family-venues": "Family-Inclusive Venues",
          "other": "Other · Institutional",
        },
        submit: "Submit request",
        submitting: "Sending…",
        success: "Thank you. Our team will reach out within 48 hours.",
        error: "Something went wrong. Please try again or write to partnership@mionga.com.",
        privacy: "By submitting you accept our institutional privacy policy.",
      },
    },
    closing: {
      brand: "MIONGA", accent: "Beverages",
      lede: "Where natural origins, German quality and modern lifestyle come together.",
      poweredBy: "Powered by",
    },
    footer: { copy: "© MIONGA Beverages · Uetze, Germany", back: "\u2190 Back to HannoNexus" },
  },

  pt: {
    nav: { vision: "Visão", ecosystem: "Ecossistema", products: "Produtos", sustainability: "Sustentabilidade", partnership: "Parceria", request: "Solicitar Parceria" },
    hero: { badge: "Ecossistema Premium de Estilo de Vida", subline: "Beverages", slogan: "\u201CSabores Naturais das Ilhas, Concebidos na Alemanha.\u201D", poweredBy: "Powered by Moin | Ol\u00e1 Coffee Connection", cta1: "Explorar o Ecossistema", cta2: "Oportunidade de Parceria", placeholder: "Hero \u2014 garrafa MIONGA \u00b7 mesa de carvalho \u00b7 café" },
    vision: { eyebrow: "A Visão", title: "Construir um Novo", accent: "Ecossistema de Estilo de Vida.", lede: "A MIONGA combina bebidas premium, cultura de café, gastronomia e hospitalidade sustentável numa experiência integrada.", pillars: ["Bebidas Premium", "Coffee Connection", "Experiência de Hospitalidade", "Conceito de Família", "Futuro Sustentável"] },
    ecosystem: { eyebrow: "Mapa do Ecossistema", title: "Ligados pelo Ofício.", center: "Centro", branches: [
      { title: "Moin | Ol\u00e1 Coffee Connection", items: ["Café Especial", "Pequeno-almoço & Brunch", "Mocktails", "Experiência Familiar"] },
      { title: "LIOMONA",            items: ["Limonadas Botânicas", "Refrigerantes Naturais"] },
      { title: "MIONGA Collection",  items: ["Água", "Sumo", "Chá", "Café"] },
    ] },
    flagship: { eyebrow: "Flagship", title: "Mais do que um café.", accent: "Um destino de estilo de vida completo.", items: ["Interiores em carvalho", "Paredes de tijolo à vista", "Coffee Bar Premium", "Lounge", "Kinderecke \u2014 espaço para crianças", "Showroom de produtos"], placeholder: "Interior flagship \u00b7 carvalho + tijolo",
      gallery: {
        title: "Por dentro do flagship",
        lede: "Três momentos que definem a casa Moin | Olá — dia, serviço e presença de rua.",
        shots: [
          { key: "interior", label: "01 · Interior de dia",    caption: "Carvalho, tijolo e luz da manhã — a catedral do quotidiano." },
          { key: "bar",      label: "02 · Bar assinatura",     caption: "Serviço de barista, arte de mocktails e o Kinderecke — um palco contínuo." },
          { key: "outdoor",  label: "03 · Presença de rua",    caption: "Calçada europeia, montra digital, entrada botânica." },
        ],
      },
    },
    products: { eyebrow: "Ecossistema de Produtos", title: "Feito com naturalidade.", accent: "Entregue com premium.", items: [
      { name: "MIONGA Water",     sub: "Água Mineral Natural · pH 7.2 · Rica em Potássio" },
      { name: "MIONGA Sparkling", sub: "Água Mineral com Gás · Refrescante e Equilibrada" },
      { name: "MIONGA Juice",     sub: "Sumos Premium · 100% Naturais · Sem Conservantes, Sem Corantes" },
      { name: "MIONGA Iced Tea",  sub: "Chá Gelado Premium · Ingredientes Selecionados" },
      { name: "MIONGA Coffee",    sub: "Blend Premium · 100% Arábica · Aroma intenso, sabor inconfundível" },
    ] },
    family: { eyebrow: "Experiência Familiar", title: "Pequenos Sabores,", accent: "Grandes Descobertas.", items: ["Moin | Ol\u00e1 Kids \u2014 menu assinatura para crianças", "Kinderecke \u2014 zona dedicada às crianças", "Bebidas saudáveis para mentes em crescimento", "Hospitalidade family-friendly"], placeholder: "Kinderecke \u00b7 experiência familiar" },
    sustainability: { eyebrow: "Sustentabilidade", title: "Operações Verdes.", accent: "Origem Responsável.", items: [
      { title: "Logística Elétrica",       body: "Frota de entrega zero-emissões nos hubs alemães." },
      { title: "Embalagem Sustentável",    body: "Vidro, materiais compostáveis, circuito fechado." },
      { title: "Origem Responsável",       body: "Parcerias direct-trade com produtores insulares." },
      { title: "Operações Verdes",         body: "Torrefactoras e cafés a energia renovável." },
    ], placeholder: "Frota elétrica \u00b7 cadeia de abastecimento sustentável" },
    connection: { eyebrow: "Conexão Internacional", accentPrefix: "Herança insular", accentBody: "encontra a qualidade alemã.", de: { name: "Alemanha", sub: "Uetze · Baixa Saxónia · Sede & Operações" }, route: "Rota Atlântica · ~3.900 km", cv: { name: "Cabo Verde", sub: "Origem insular · Praia · Sourcing" }, distanceLabel: "Distância", distanceValue: "~3.900 km", routeLabel: "Rota", routeValue: "Corredor Atlântico" },
    applications: { eyebrow: "Aplicações da Marca", title: "Uma identidade,", accent: "cada ponto de contacto.", lede: "Do porão do camião ao polo do barista — a identidade MIONGA viaja consistentemente por todas as superfícies operacionais.", items: [
      { key: "cargo",   label: "Frota Cargo",     sub: "Camiões com livraria completa" },
      { key: "uniform", label: "Uniforme da Equipa", sub: "Polo · Boné · Avental" },
      { key: "glass",   label: "Copo Assinatura", sub: "Vidro gravado" },
      { key: "bag",     label: "Saco Retalho",    sub: "Takeaway premium" },
      { key: "hangtag", label: "Hang Tag",        sub: "Etiquetagem de produto" },
    ] },
    model: { eyebrow: "Modelo de Negócio", title: "Receita", accent: "Ao Longo do Dia.", items: [
      { time: "Manhã",     what: "Café & Pequeno-almoço" },
      { time: "Dia",       what: "Almoço & Refrescos" },
      { time: "Tarde",     what: "Experiência de Café" },
      { time: "Eventos",   what: "Hospitalidade \u00b7 Parcerias" },
      { time: "B2B",       what: "Hotéis \u00b7 Resorts \u00b7 Aviação" },
    ] },
    partnership: { eyebrow: "Parceria", title: "Alianças", accent: "Estratégicas.", lede: "A MIONGA associa-se a redes premium de hospitalidade, aviação e distribuição para entregar uma experiência integrada.", targets: ["Hotéis de Luxo", "Resorts", "Companhias Aéreas", "Investidores", "Distribuição", "Institucional"], cta: "Solicitar Parceria MIONGA",
      form: {
        title: "Solicitar um briefing de parceria",
        lede: "Dossier executivo entregue em 48 horas. Todas as submissões são confidenciais.",
        name: "Nome completo", company: "Empresa / Organização", role: "Função (opcional)",
        country: "País", email: "Email institucional", phone: "Telefone (opcional)",
        interest: "Área de interesse", message: "Pedido de briefing",
        interestOptions: {
          "hotels": "Hotéis de Luxo & Resorts",
          "fine-dining": "Alta Gastronomia · Hospitalidade",
          "retail": "Retalho Premium",
          "aviation": "Aviação & Lounges",
          "family-venues": "Espaços Familiares",
          "other": "Outro · Institucional",
        },
        submit: "Enviar pedido",
        submitting: "A enviar…",
        success: "Obrigado. A nossa equipa entrará em contacto em 48 horas.",
        error: "Ocorreu um erro. Tente novamente ou escreva para partnership@mionga.com.",
        privacy: "Ao submeter aceita a nossa política institucional de privacidade.",
      },
    },
    closing: { brand: "MIONGA", accent: "Beverages", lede: "Onde origens naturais, qualidade alemã e estilo de vida moderno se unem.", poweredBy: "Powered by" },
    footer: { copy: "© MIONGA Beverages \u00b7 Uetze, Alemanha", back: "\u2190 Voltar ao HannoNexus" },
  },

  de: {
    nav: { vision: "Vision", ecosystem: "Ökosystem", products: "Produkte", sustainability: "Nachhaltigkeit", partnership: "Partnerschaft", request: "Partnerschaft anfragen" },
    hero: { badge: "Premium Lifestyle-Ökosystem", subline: "Beverages", slogan: "\u201ENatürliche Aromen von den Inseln, gefertigt in Deutschland.\u201C", poweredBy: "Powered by Moin | Ol\u00e1 Coffee Connection", cta1: "Ökosystem entdecken", cta2: "Partnerschaftsmöglichkeit", placeholder: "Hero \u2014 MIONGA-Flasche \u00b7 Eichentisch \u00b7 Kaffee" },
    vision: { eyebrow: "Die Vision", title: "Ein neues", accent: "Lifestyle-Ökosystem aufbauen.", lede: "MIONGA verbindet Premium-Getränke, Kaffeekultur, Gastronomie und nachhaltige Gastfreundschaft zu einem integrierten Erlebnis.", pillars: ["Premium Getränke", "Coffee Connection", "Gastronomie-Erlebnis", "Familienkonzept", "Nachhaltige Zukunft"] },
    ecosystem: { eyebrow: "Ökosystem-Karte", title: "Durch Handwerk verbunden.", center: "Zentrum", branches: [
      { title: "Moin | Ol\u00e1 Coffee Connection", items: ["Spezialitätenkaffee", "Frühstück & Brunch", "Mocktails", "Familienerlebnis"] },
      { title: "LIOMONA",            items: ["Botanische Limonaden", "Natürliche Erfrischungen"] },
      { title: "MIONGA Collection",  items: ["Wasser", "Saft", "Tee", "Kaffee"] },
    ] },
    flagship: { eyebrow: "Flagship-Erlebnis", title: "Mehr als ein Café.", accent: "Ein komplettes Lifestyle-Ziel.", items: ["Eichenholz-Interieur", "Sichtziegelwände", "Premium Coffee Bar", "Lounge", "Kinderecke", "Produkt-Showroom"], placeholder: "Flagship-Interieur \u00b7 Eiche + Ziegel",
      gallery: {
        title: "Blick ins Flagship",
        lede: "Drei prägende Momente des Hauses Moin | Olá — Tag, Service und Straßenpräsenz.",
        shots: [
          { key: "interior", label: "01 · Interieur bei Tag",  caption: "Eiche, Ziegel und Morgenlicht — die Alltagskathedrale." },
          { key: "bar",      label: "02 · Signature-Bar",       caption: "Barista-Service, Mocktail-Handwerk und Kinderecke — eine durchgehende Bühne." },
          { key: "outdoor",  label: "03 · Straßenpräsenz",      caption: "Europäisches Kopfsteinpflaster, digitale Schaufront, botanischer Eingang." },
        ],
      },
    },
    products: { eyebrow: "Produkt-Ökosystem", title: "Natürlich gefertigt.", accent: "Premium geliefert.", items: [
      { name: "MIONGA Water",     sub: "Natürliches Mineralwasser · pH 7,2 · Reich an Kalium" },
      { name: "MIONGA Sparkling", sub: "Mineralwasser mit Kohlensäure · Erfrischend & ausgewogen" },
      { name: "MIONGA Juice",     sub: "Premium-Säfte · 100% natürlich · Ohne Konservierungs- und Farbstoffe" },
      { name: "MIONGA Iced Tea",  sub: "Premium Eistee · Handverlesene Zutaten" },
      { name: "MIONGA Coffee",    sub: "Premium-Blend · 100% Arabica · Intensives Aroma, unverwechselbarer Geschmack" },
    ] },
    family: { eyebrow: "Familienerlebnis", title: "Kleine Aromen,", accent: "Grosse Entdeckungen.", items: ["Moin | Ol\u00e1 Kids \u2014 Signature-Menü für Kinder", "Kinderecke \u2014 Kinderbereich", "Gesunde Getränke für wachsende Köpfe", "Familienfreundliche Gastronomie"], placeholder: "Kinderecke \u00b7 Familienerlebnis" },
    sustainability: { eyebrow: "Nachhaltigkeit", title: "Grüne Operationen.", accent: "Verantwortungsvolle Beschaffung.", items: [
      { title: "Elektrische Logistik",     body: "Emissionsfreie Lieferflotte in deutschen Hubs." },
      { title: "Nachhaltige Verpackung",   body: "Glasflaschen, kompostierbare Materialien, Kreislauf." },
      { title: "Verantwortliche Beschaffung", body: "Direct-Trade-Partnerschaften mit Inselerzeugern." },
      { title: "Grüne Operationen",        body: "Röstereien und Cafés mit erneuerbarer Energie." },
    ], placeholder: "Elektroflotte \u00b7 nachhaltige Lieferkette" },
    connection: { eyebrow: "Internationale Verbindung", accentPrefix: "Insel-Erbe", accentBody: "trifft deutsche Qualität.", de: { name: "Deutschland", sub: "Uetze · Niedersachsen · HQ & Betrieb" }, route: "Atlantik-Route · ~3.900 km", cv: { name: "Kap Verde", sub: "Insel-Ursprünge · Praia · Beschaffung" }, distanceLabel: "Entfernung", distanceValue: "~3.900 km", routeLabel: "Route", routeValue: "Atlantik-Korridor" },
    applications: { eyebrow: "Markenanwendungen", title: "Eine Identität,", accent: "jeder Berührungspunkt.", lede: "Vom Frachtraum bis zum Poloshirt des Baristas — die MIONGA-Identität reist konsequent über jede operative Oberfläche.", items: [
      { key: "cargo",   label: "Fracht-Flotte",   sub: "Vollbeklebte LKWs" },
      { key: "uniform", label: "Team-Uniform",    sub: "Polo · Cap · Schürze" },
      { key: "glass",   label: "Signature-Glas",  sub: "Graviertes Trinkglas" },
      { key: "bag",     label: "Retail-Tasche",   sub: "Premium Takeaway" },
      { key: "hangtag", label: "Hang Tag",        sub: "Produkt-Etikettierung" },
    ] },
    model: { eyebrow: "Geschäftsmodell", title: "Umsatz", accent: "Rund um die Uhr.", items: [
      { time: "Morgen",     what: "Kaffee & Frühstück" },
      { time: "Tag",        what: "Mittagessen & Erfrischungen" },
      { time: "Nachmittag", what: "Kaffee-Erlebnis" },
      { time: "Events",     what: "Gastronomie \u00b7 Partnerschaften" },
      { time: "B2B",        what: "Hotels \u00b7 Resorts \u00b7 Aviation" },
    ] },
    partnership: { eyebrow: "Partnerschaft", title: "Strategische", accent: "Allianzen.", lede: "MIONGA arbeitet mit Premium-Gastronomie, Aviation und Distributionsnetzwerken für ein integriertes Lifestyle-Erlebnis.", targets: ["Luxushotels", "Resorts", "Airlines", "Investoren", "Distribution", "Institutionell"], cta: "MIONGA Partnerschaft anfragen",
      form: {
        title: "Partnerschafts-Briefing anfragen",
        lede: "Executive-Dossier innerhalb von 48 Stunden. Alle Einreichungen vertraulich.",
        name: "Vollständiger Name", company: "Unternehmen / Organisation", role: "Rolle (optional)",
        country: "Land", email: "Geschäftliche E-Mail", phone: "Telefon (optional)",
        interest: "Interessengebiet", message: "Briefing-Anfrage",
        interestOptions: {
          "hotels": "Luxushotels & Resorts",
          "fine-dining": "Fine Dining · Gastronomie",
          "retail": "Premium-Einzelhandel",
          "aviation": "Aviation & Lounges",
          "family-venues": "Familienfreundliche Locations",
          "other": "Sonstiges · Institutionell",
        },
        submit: "Anfrage senden",
        submitting: "Wird gesendet…",
        success: "Vielen Dank. Unser Team meldet sich innerhalb von 48 Stunden.",
        error: "Etwas ist schiefgelaufen. Bitte erneut versuchen oder an partnership@mionga.com schreiben.",
        privacy: "Mit dem Absenden akzeptieren Sie unsere institutionelle Datenschutzrichtlinie.",
      },
    },
    closing: { brand: "MIONGA", accent: "Beverages", lede: "Wo natürliche Ursprünge, deutsche Qualität und moderner Lifestyle zusammenkommen.", poweredBy: "Powered by" },
    footer: { copy: "© MIONGA Beverages \u00b7 Uetze, Deutschland", back: "\u2190 Zurück zu HannoNexus" },
  },

  fr: {
    nav: { vision: "Vision", ecosystem: "Écosystème", products: "Produits", sustainability: "Durabilité", partnership: "Partenariat", request: "Demander un partenariat" },
    hero: { badge: "Écosystème Premium Art de Vivre", subline: "Beverages", slogan: "\u00abSaveurs naturelles des îles, façonnées en Allemagne.\u00bb", poweredBy: "Powered by Moin | Ol\u00e1 Coffee Connection", cta1: "Explorer l'écosystème", cta2: "Opportunité de partenariat", placeholder: "Hero \u2014 bouteille MIONGA \u00b7 table en chêne \u00b7 café" },
    vision: { eyebrow: "La Vision", title: "Construire un nouvel", accent: "écosystème art de vivre.", lede: "MIONGA combine boissons premium, culture du café, gastronomie et hospitalité durable en une expérience intégrée.", pillars: ["Boissons Premium", "Coffee Connection", "Expérience Hospitalière", "Concept Famille", "Avenir Durable"] },
    ecosystem: { eyebrow: "Carte de l'écosystème", title: "Unis par l'artisanat.", center: "Centre", branches: [
      { title: "Moin | Ol\u00e1 Coffee Connection", items: ["Café de spécialité", "Petit-déjeuner & Brunch", "Mocktails", "Expérience familiale"] },
      { title: "LIOMONA",            items: ["Limonades botaniques", "Rafraîchissements naturels"] },
      { title: "MIONGA Collection",  items: ["Eau", "Jus", "Thé", "Café"] },
    ] },
    flagship: { eyebrow: "Expérience flagship", title: "Plus qu'un café.", accent: "Une destination art de vivre complète.", items: ["Intérieurs en chêne", "Murs en briques apparentes", "Coffee Bar Premium", "Salon", "Kinderecke \u2014 espace enfants", "Showroom produits"], placeholder: "Intérieur flagship \u00b7 chêne + briques",
      gallery: {
        title: "À l'intérieur du flagship",
        lede: "Trois moments définissant la maison Moin | Olá — jour, service et présence de rue.",
        shots: [
          { key: "interior", label: "01 · Intérieur de jour",   caption: "Chêne, brique et lumière du matin — la cathédrale du quotidien." },
          { key: "bar",      label: "02 · Bar signature",       caption: "Service barista, mocktails d'auteur et Kinderecke — une scène continue." },
          { key: "outdoor",  label: "03 · Présence de rue",     caption: "Pavés de Hambourg, vitrine digitale, entrée botanique." },
        ],
      },
    },
    products: { eyebrow: "Écosystème produit", title: "Fabriqué naturellement.", accent: "Livré premium.", items: [
      { name: "MIONGA Water",     sub: "Eau minérale naturelle · pH 7,2 · Riche en potassium" },
      { name: "MIONGA Sparkling", sub: "Eau minérale gazeuse · Rafraîchissante & équilibrée" },
      { name: "MIONGA Juice",     sub: "Jus premium · 100% naturels · Sans conservateurs ni colorants" },
      { name: "MIONGA Iced Tea",  sub: "Thé glacé premium · Ingrédients sélectionnés" },
      { name: "MIONGA Coffee",    sub: "Blend premium · 100% Arabica · Arôme intense, saveur inimitable" },
    ] },
    family: { eyebrow: "Expérience Famille", title: "Petites saveurs,", accent: "Grandes découvertes.", items: ["Moin | Ol\u00e1 Kids \u2014 menu signature enfants", "Kinderecke \u2014 espace dédié aux enfants", "Boissons saines pour esprits en croissance", "Hospitalité family-friendly"], placeholder: "Kinderecke \u00b7 expérience famille" },
    sustainability: { eyebrow: "Durabilité", title: "Opérations vertes.", accent: "Sourcing responsable.", items: [
      { title: "Logistique Électrique",   body: "Flotte de livraison zéro émission dans les hubs allemands." },
      { title: "Emballage Durable",       body: "Verre, matériaux compostables, boucle fermée." },
      { title: "Sourcing Responsable",    body: "Partenariats direct-trade avec producteurs insulaires." },
      { title: "Opérations Vertes",       body: "Torréfacteurs et cafés en énergie renouvelable." },
    ], placeholder: "Flotte électrique \u00b7 chaîne d'approvisionnement durable" },
    connection: { eyebrow: "Connexion Internationale", accentPrefix: "Héritage insulaire", accentBody: "rencontre qualité allemande.", de: { name: "Allemagne", sub: "Uetze · Basse-Saxe · Siège & Opérations" }, route: "Route Atlantique · ~3 900 km", cv: { name: "Cap-Vert", sub: "Origines insulaires · Praia · Sourcing" }, distanceLabel: "Distance", distanceValue: "~3 900 km", routeLabel: "Route", routeValue: "Corridor Atlantique" },
    applications: { eyebrow: "Applications de la marque", title: "Une identité,", accent: "chaque point de contact.", lede: "De la soute au polo du barista — l'identité MIONGA voyage de façon cohérente sur chaque surface opérationnelle.", items: [
      { key: "cargo",   label: "Flotte Cargo",    sub: "Camions habillés intégralement" },
      { key: "uniform", label: "Uniforme d'équipe", sub: "Polo · Casquette · Tablier" },
      { key: "glass",   label: "Verre signature", sub: "Verrerie gravée" },
      { key: "bag",     label: "Sac Retail",      sub: "Emporter premium" },
      { key: "hangtag", label: "Hang Tag",        sub: "Étiquetage produit" },
    ] },
    model: { eyebrow: "Modèle Économique", title: "Revenus", accent: "Toute la journée.", items: [
      { time: "Matin",       what: "Café & Petit-déjeuner" },
      { time: "Jour",        what: "Déjeuner & Rafraîchissements" },
      { time: "Après-midi",  what: "Expérience Café" },
      { time: "Événements",  what: "Hospitalité \u00b7 Partenariats" },
      { time: "B2B",         what: "Hôtels \u00b7 Resorts \u00b7 Aviation" },
    ] },
    partnership: { eyebrow: "Partenariat", title: "Alliances", accent: "Stratégiques.", lede: "MIONGA s'associe aux réseaux premium d'hospitalité, d'aviation et de distribution pour livrer une expérience intégrée.", targets: ["Hôtels de Luxe", "Resorts", "Compagnies Aériennes", "Investisseurs", "Distribution", "Institutionnel"], cta: "Demander un partenariat MIONGA",
      form: {
        title: "Demander un briefing de partenariat",
        lede: "Dossier exécutif livré sous 48 heures. Toutes les soumissions sont confidentielles.",
        name: "Nom complet", company: "Société / Organisation", role: "Fonction (optionnel)",
        country: "Pays", email: "Email professionnel", phone: "Téléphone (optionnel)",
        interest: "Domaine d'intérêt", message: "Demande de briefing",
        interestOptions: {
          "hotels": "Hôtels de Luxe & Resorts",
          "fine-dining": "Gastronomie · Hospitalité",
          "retail": "Retail Premium",
          "aviation": "Aviation & Lounges",
          "family-venues": "Lieux Famille",
          "other": "Autre · Institutionnel",
        },
        submit: "Envoyer la demande",
        submitting: "Envoi…",
        success: "Merci. Notre équipe vous contactera sous 48 heures.",
        error: "Une erreur est survenue. Veuillez réessayer ou écrire à partnership@mionga.com.",
        privacy: "En soumettant, vous acceptez notre politique de confidentialité institutionnelle.",
      },
    },
    closing: { brand: "MIONGA", accent: "Beverages", lede: "Où origines naturelles, qualité allemande et art de vivre moderne se rejoignent.", poweredBy: "Powered by" },
    footer: { copy: "© MIONGA Beverages \u00b7 Hambourg, Allemagne", back: "\u2190 Retour à HannoNexus" },
  },
};

/**
 * Detects the best-matching supported language from the browser and persists it.
 * Runs once per session on first visit; subsequent visits honour the user's choice
 * (via the LanguageSwitcher writing to localStorage.hx_lang).
 */
const SUPPORTED = ["en", "pt", "de", "fr"];

export function detectAndPersistLang() {
  if (typeof window === "undefined") return "en";
  const stored = localStorage.getItem("hx_lang");
  if (stored && SUPPORTED.includes(stored)) return stored;

  // navigator.languages is preferred (ordered list); fall back to navigator.language
  const candidates = (navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language || "en"]);

  // Special-case: Germany, Austria, Switzerland, Luxembourg → DE
  // Portugal, Brazil, Angola, Cape Verde, Mozambique → PT
  // France, Belgium, Canada-FR, Switzerland-FR → FR
  // Everything else → EN
  for (const raw of candidates) {
    if (!raw) continue;
    const l = raw.toLowerCase();
    const base = l.split("-")[0];
    if (base === "pt") { localStorage.setItem("hx_lang", "pt"); return "pt"; }
    if (base === "de") { localStorage.setItem("hx_lang", "de"); return "de"; }
    if (base === "fr") { localStorage.setItem("hx_lang", "fr"); return "fr"; }
    if (base === "en") { localStorage.setItem("hx_lang", "en"); return "en"; }
  }
  localStorage.setItem("hx_lang", "en");
  return "en";
}

export function useMiongaContent() {
  const lang = detectAndPersistLang();
  return M[lang] || M.en;
}
